import React, {
  createContext,
  useState,
  useRef,
  useCallback,
  useContext,
} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";

const ConfirmContext = createContext();

export const useConfirm = () => useContext(ConfirmContext);

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    title: "",
    message: "",
    requireReason: false,
  });
  const [input, setInput] = useState("");
  const resolver = useRef();

  const confirm = useCallback(({ title, message, requireReason = false }) => {
    setState({ open: true, title, message, requireReason });
    setInput(""); // clear input
    return new Promise((resolve) => {
      resolver.current = resolve;
    });
  }, []);

  const handleClose = (result) => {
    setState((prev) => ({ ...prev, open: false }));
    if (resolver.current) {
      resolver.current(
        result
          ? state.requireReason
            ? { confirmed: true, reason: input?.trim() || null }
            : true
          : false
      );
      resolver.current = null;
    }
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      <Dialog open={state.open} onClose={() => handleClose(false)} fullWidth>
        {state.title && <DialogTitle>{state.title}</DialogTitle>}
        <DialogContent>
          <Typography>{state.message}</Typography>
          {state.requireReason && (
            <TextField
              autoFocus
              margin="dense"
              label="Remarks (optional)"
              type="text"
              fullWidth
              multiline
              minRows={2}
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>Cancel</Button>
          <Button
            onClick={() => handleClose(true)}
            autoFocus
            variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </ConfirmContext.Provider>
  );
};
